import React from 'react';
import {
  Box,
  Icon,
  InlineMessage,
  InputField,
  Typography,
} from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../../../hooks';
import { MOCK_PREDEFINED_COMMENTS } from '../../mockRemediateList';

import './SodRemediateSubmitComment.css';

interface SodRemediateSubmitCommentProps {
  commentValue: string;
  setCommentValue: (value: string) => void;
  isSubmittingComment: boolean;
  isCommentCritical: boolean;
}

/**
 * TODO:
 * - Write description
 */
function SodRemediateSubmitComment({
  commentValue,
  setCommentValue,
  isSubmittingComment,
  isCommentCritical,
}: SodRemediateSubmitCommentProps) {
  const l = useInvertedLocalize();

  return (
    <Box tabIndex={-1} className='SodRemediateSubmitComment'>
      <InputField
        name='remediate-submit-comment'
        kind='multiline'
        label={
          <Typography kind='label' htmlFor='remediate-submit-comment'>
            {l('Comments')}
          </Typography>
        }
        tabIndex={!isSubmittingComment ? -1 : 0}
        isDisabled={!isSubmittingComment}
        value={commentValue}
        setValue={setCommentValue}
        predefinedOptions={MOCK_PREDEFINED_COMMENTS}
        predefinedOptionsConfig={{ lineLimit: 1 }}
        classNames={{
          predefinedOptionChip:
            'SodRemediateSubmitComment-predefinedOptionsChip',
        }}
        placeholder={l('Provide a reason for your decision')}
        isRequired={commentValue.length < 1 || isCommentCritical}
        isCritical={isCommentCritical}
        CriticalHelperText={
          <InlineMessage
            kind='missingRequiredField'
            colorTheme='critical'
            size='small'
            leftIcon={<Icon kind='AlertCriticalFilled' />}
          />
        }
      />
    </Box>
  );
}

export default SodRemediateSubmitComment;
